import { Component, OnInit, ViewChild } from '@angular/core';
import { exportPDF, Group } from '@progress/kendo-drawing';

@Component({
  selector: 'app-appeal-request-form',
  templateUrl: './appeal-request-form.component.html',
  styleUrls: ['./appeal-request-form.component.scss']
})
export class AppealRequestFormComponent implements OnInit {

  @ViewChild("pdfAppealRequestForm") pdfAppealRequestForm;
  constructor() { }

  ngOnInit(): void {
  }
  PDFDownload(){
    this.DownloadAppealRequestForm();
  }
  DownloadAppealRequestForm() {    
    (this.pdfAppealRequestForm.A4 = true),
      (this.pdfAppealRequestForm.portrait = true),
      (this.pdfAppealRequestForm.keepTogether = ".prevent-split"),
      (this.pdfAppealRequestForm.scale = 0.8),
      (this.pdfAppealRequestForm.height = 100),
      this.pdfAppealRequestForm.padding = { bottom: "40px" };
    this.pdfAppealRequestForm.forcePageBreak = ".page-header";
    this.pdfAppealRequestForm.saveAs(
      "Appeal Request Form" +
      new Date().toLocaleDateString() +
      "-" +
      new Date().toLocaleTimeString()
    );
  }

printForm(): void {
  (this.pdfAppealRequestForm.A4 = true),
    (this.pdfAppealRequestForm.portrait = true),
    (this.pdfAppealRequestForm.keepTogether = ".prevent-split"),
    (this.pdfAppealRequestForm.scale = 0.6),
    (this.pdfAppealRequestForm.height = 100),
    (this.pdfAppealRequestForm.margin = {
      left: "1cm",
      top: "1cm",
      right: "0.2cm",
      bottom: "1cm",
    });
  this.pdfAppealRequestForm.padding = { bottom: "50px" };
  this.pdfAppealRequestForm.forcePageBreak = ".page-header";
  this.pdfAppealRequestForm
    .export()
    .then((completedata: Group) => exportPDF(completedata))
    .then(async (base64) => {
      const fileObject = this.dataURLtoFile(base64, "test");
      var fileurl = URL.createObjectURL(fileObject);
      var Output = window.open(fileurl, "", "height=500, width=500");
      Output.print();
    });
}

// .....................................................dataURLtoFile...........................................
public dataURLtoFile(dataurl, filename) {
var arr = dataurl.split(","),
  mime = arr[0].match(/:(.*?);/)[1],
  bstr = atob(arr[1]),
  n = bstr.length,
  u8arr = new Uint8Array(n);
while (n--) {
  u8arr[n] = bstr.charCodeAt(n);
}
return new File([u8arr], filename, { type: mime });
}

}
